<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-input--label">{{ $t('menuOrganization.branch') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                              :options="organizationBranchOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                    <label class="vs-input--label">Phòng ban</label>
                    <v-select class="" v-model="departmentId" :clearable="false"
                              :options="departmentOptions" :reduce="item => item.value">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full md:mt-0 mt-2">
                    <label class="vs-input--label">Trạng thái ảnh</label>
                    <v-select class="" v-model="haveImage" :clearable="false"
                              :options="haveImageOptions" :reduce="item => item.value">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full xl:mt-0 mt-2">
                    <label class="vs-input--label">Tìm kiếm</label>
                    <vs-input class="w-full" v-model="keySearch" :placeholder="$t('button.search')" @keyup.enter="filter"/>
                </div>
            </div>
            <div class="flex flex-wrap items-center mt-5">
                <div class="flex flex-grow">
                    <vs-button @click="filter" color="primary" type="border" icon-pack="feather" icon="icon-search">
                        {{ $t('button.search') }}
                    </vs-button>
                    <vs-button @click="addEmployee" color="primary" icon-pack="feather" icon="icon-plus" class="ml-2">
                        {{ $t('button.addEmployee') }}
                    </vs-button>
                    <vs-button @click="downloadTemplate" color="primary" icon-pack="feather" icon="icon-download"
                               class="ml-2" v-if="selectedOrganizationBranchValue">
                        Tải xuống tệp mẫu
                    </vs-button>
                    <vs-button @click="$refs.fileUpload.click()" color="primary" icon-pack="feather" icon="icon-upload"
                               class="ml-2" v-if="selectedOrganizationBranchValue">
                        Tải lên tệp nhân viên
                    </vs-button>
                    <vs-button @click="confirmDeleteMultiple" color="danger" type="border" icon-pack="feather"
                               icon="icon-trash-2"
                               class="ml-2" v-if="isSelected">
                        Xóa nhiều
                    </vs-button>
                    <input ref="fileUpload" type="file" id="fileUpload" accept=".xlsx, .xls, .csv, .xlsm, .xlsb"
                           class="hidden" @change="uploadFile($event)">
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="employeeData"
                         :animateRows="true"
                         :localeText="  {noRowsToShow: this.$t('menuCustomer.noRowsToShow')} "
                         :onGridReady="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy"
                         :suppressRowClickSelection="true"
                         :rowSelection="'multiple'"
                         @row-selected="onRowSelected"
                         tooltipShowDelay="0"
                         tooltipHideDelay="5000"
                         :tooltipMouseTrack="true">
            </ag-grid-vue>

            <div class="vx-row" v-if="employeeData && employeeData.length > 0">
                <div class="vx-col md:w-1/2">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                        <span class="vx-col mt-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        employeeData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : employeeData.length
                                    }} /
                                    {{ totalElements }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>

                                <vs-dropdown-item @click="changePageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPages" v-model="currentPage" @input="loadPage"/>
                </div>
            </div>
        </div>

        <vs-popup class="holamundo popupError" title="Lỗi tải lên tệp nhân viên" :active.sync="popupErrorImport">
            <div class="">
                <div>
                    <vs-table stripe :data="errorData" pagination max-items="10">
                        <template slot="thead">
                            <vs-th> STT</vs-th>
                            <vs-th> Trường dữ liệu</vs-th>
                            <vs-th> Hàng</vs-th>
                            <vs-th> Cột</vs-th>
                            <vs-th> Lỗi</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(item, indextr) in data">
                                <vs-td> {{ item.stt }}</vs-td>

                                <vs-td> {{ item.header }}</vs-td>

                                <vs-td> {{ item.rowNumError }}</vs-td>

                                <vs-td> {{ item.colChar }}</vs-td>

                                <vs-td> {{ item.message }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </vs-popup>

    </div>
</template>

<script>
import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import {ClientSideRowModelModule} from '@ag-grid-community/client-side-row-model';
import {ModuleRegistry} from '@ag-grid-community/core';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import Pagination from "../../ui-elements/Pagination.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
// import {isAPI, isRouter} from "../../../store/permission";
// import {constAPI, constRouter} from "../../../store/constant";
import authConfig from '@/../auth_config.json';

// Register the required feature modules with the Grid
ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        CellRendererStatus,
        CellRendererActions,
        Pagination
    },
    data() {
        return {
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                flex: 1,
            },
            rowSelection: null,
            columnDefs: [
                {
                    headerName: 'STT',
                    field: 'stt',
                    minWidth: 100,
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionFilteredOnly: true,
                    checkboxSelection: true,
                },
                {
                    headerName: this.$t('menuOrganization.employeeCode'),
                    field: 'employeeCode',
                    width: 150,
                },
                {
                    headerName: this.$t('menuOrganization.employeeName'),
                    field: 'fullName',
                    width: 200,
                    tooltipField: 'fullName',
                },
                {
                    headerName: this.$t('menuOrganization.address'),
                    field: 'fullAddress',
                    width: 200,
                    tooltipField: 'fullAddress',
                },
                {
                    headerName: this.$t('menuOrganization.phoneNumber'),
                    field: 'phoneNumber',
                    width: 200,
                    tooltipField: 'phoneNumber',
                },
                {
                    headerName: this.$t('menuOrganization.status'),
                    field: 'enabledString',
                    cellRenderer: 'CellRendererStatus',
                    width: 200,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRenderer: 'CellRendererActions',
                },
            ],
            employeeData: [],
            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            userInfo: null,
            popupErrorImport: false,
            errorData: [],
            pageNumber: 0,
            pageSize: 30,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            keySearch: null,
            departmentId: 'null',
            departmentOptions: [],
            haveImage: null,
            haveImageOptions: [
                {value: null, label: 'Tất cả'},
                {value: true, label: 'Đã có ảnh'},
                {value: false, label: 'Chưa có ảnh'},
            ],
            isSelected: false,
            dataSelected: [],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
        }
    },
    created() {
        this.rowSelection = 'multiple';
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateEmployee'(val) {
            if (val) {
                this.filter();
                this.$store.commit('UPDATE_EMPLOYEE', false);
            }
        }
    },
    computed: {
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            async set(obj) {
                this.selectedOrganizationBranchValue = obj ? obj.value : null;
                this.departmentId = 'null';
                if (this.selectedOrganizationBranchValue) await this.getDepartment();
            }
        }
    },
    methods: {
        // isPermissionAdd() {
        //     return isAPI(this, constAPI.employee_add);
        // },
        // isPermissionUpdateAI() {
        //     return isRouter(this, constRouter.employee_edit)
        // },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || this.$t('menuOrganization.null');
        },
        downloadTemplate() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.$vs.loading();
            this.$crm.post(`/employee/download-template/${userInfo.organization.id}/${this.selectedOrganizationBranchValue}`).then(res => {
                window.open(authConfig.crmDomain + "file/beauty/" + res.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        isExcel(file) {
            return /\.(xlsx|xls|csv|xlsm|xlsb)$/.test(file.name)
        },
        uploadFile(e) {
            let file = [...e.target.files];
            if (!this.isExcel(file[0])) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Chỉ hỗ trợ tệp có định dạng .xlsx, .xls, .csv, .xlsm, .xlsb',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }

            let formData = new FormData();
            formData.append('file', file[0]);
            this.errorData = [];
            this.$vs.loading();
            this.$crm.post(`/employee/import-excel-employee/${this.selectedOrganizationBranchValue}`, formData).then(res => {
                if (res.data && res.data.length > 0) {
                    this.popupErrorImport = true;
                    this.errorData = res.data.map(el => {
                        el.stt = res.data.indexOf(el) + 1;
                        return el;
                    });
                } else {
                    this.filter();
                }
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
            this.$refs.fileUpload.value = null;
        },
        addEmployee() {
            if (this.organizationBranchOptions.length === 0 && !this.selectedOrganizationBranchValue) {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: this.$t('button.addEmployee'),
                    text: `Chưa có chi nhánh nào, vui lòng thêm chi nhánh trước.`,
                    accept: this.acceptGoToAddBranch,
                    acceptText: this.$t('button.agree'),
                    cancelText: this.$t('button.cancel')
                })
                return;
            }
            if (this.selectedOrganizationBranchValue == null) {
                // let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                // this.selectedOrganizationBranchValue = userInfo.organization.id
                this.selectedOrganizationBranchValue = this.organizationBranchOptions[1].value
                this.$router.push(`/user/add-employee?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
                });
            }
            if (this.selectedOrganizationBranchValue) {
                this.$router.push(`/user/add-employee?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
                });
            }
        },
        acceptGoToAddBranch() {
            this.$router.push(`/user/add-organization-branch`).catch(() => {
            });
        },
        onGridReady() {
            // if (this.$store.state.windowWidth > 1024) {
            //     this.gridApi.sizeColumnsToFit();
            // }
        },

        async initScreen() {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                return this.$vs.notify({
                    text: this.$t('warningMenuOrganization.emptyEmployee'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(item => {
                return {value: item.id, label: item.organizationBranchName}
            });
            this.organizationBranchOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
            let branchId = parseInt(this.$route.query.branch_id, 10);
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value === branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            await this.getDepartment();
            this.loadAllEmployee();
        },

        loadAllEmployee() {
            this.$vs.loading();
            let payload = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                organizationId: this.userInfo.organization.id,
                departmentId: JSON.parse(this.departmentId),
                haveImage: this.haveImage,
                keySearch: this.keySearch,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
            }

            this.$crm.post('/employee/find-by-condition', payload).then(res => {
                this.$vs.loading.close();
                if (res.data.content && res.data.content.length > 0) {
                    res.data.content.forEach(x => {
                        x.stt = this.pageSize * this.pageNumber + res.data.content.indexOf(x) + 1;
                        if (x.enabled) {
                            x.enabledString = this.$t('employeeStatus.working');
                        } else {
                            x.enabledString = this.$t('employeeStatus.offWork');
                        }
                    });
                }
                this.employeeData = res.data.content;

                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;

                setTimeout(() => {
                    this.onGridReady();
                }, 100);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getDepartment() {
            return new Promise((resolve, reject) => {
                let payload = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    organizationId: this.userInfo.organization.id
                }
                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', payload).then(res => {
                    this.$vs.loading.close();
                    if (res.data && res.data.length > 0) {
                        this.departmentOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.departmentName
                            }
                        })
                    }
                    this.departmentOptions.unshift({value: 'null', label: 'Tất cả'})
                    resolve(res)
                }).catch((err) => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        loadPage: function (currentPage) {
            this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
            this.loadAllEmployee();
        },

        changePageSize(number) {
            this.pageSize = number;
            this.filter();
        },

        filter() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.loadAllEmployee();
        },

        confirmDeleteMultiple() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá ${this.dataSelected.length} nhân viên đã chọn không ?`,
                accept: this.deleteMultiple,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        async deleteMultiple() {
            this.$vs.loading();
            let isSuccess = true;
            for (let i = 0; i < this.dataSelected.length; i++) {
                await this.$crm.post('/employee/delete/' + this.dataSelected[i]).catch(() => {
                    isSuccess = false
                })
            }
            this.$vs.notify({
                text: `Xóa nhân sự ${isSuccess ? '' : 'không'} thành công!`,
                iconPack: 'feather',
                icon: `${isSuccess ? 'icon-check-circle' : 'icon-alert-circle'}`,
                color: `${isSuccess ? 'success' : 'danger'}`
            });
            this.isSelected = false;
            this.$vs.loading.close();
            this.filter();
        },

        onRowSelected(event) {
            this.isSelected = !!(event.api.getSelectedNodes().length > 0);
            if (this.isSelected) {
                this.dataSelected = event.api.getSelectedNodes().map(x => {
                    return x.data.id;
                });
            } else {
                this.dataSelected = [];
            }
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style lang="scss">

</style>
